import React, { useEffect, useState } from "react";

import "./Login";
import { useNavigate } from "react-router-dom";

const Logo = () => {
  const [redirect, setRedirect] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const timeout = setTimeout(() => {
      setRedirect(true);
    }, 3000);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  useEffect(() => {
    if (redirect) {
      navigate("/login");
    
      // navigate('/AllowHotelMadina');
      // navigate('/AllowHotelJeddah');
      // navigate('/GridFilters');
      // navigate('/reset-password');
      // navigate('/transport');
      // navigate('/actual-hotel');
      // navigate('/datatable-plus');
    }
  }, [redirect, navigate]);

  return (
    <div>
      <div className="background-image-hotel-logo">
        <img className="logo" src={window.firstpage} alt="logo" />
      </div>
    </div>
  );
};

export default Logo;
